import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
  import LotApproveModal from "@/components/ui/modals/LotApproveModal.vue";
  import AttentionModal from "@/components/ui/modals/AttentionModal.vue";
  import EOIApprovalModal from "../ui/modals/EOIApprovalModal.vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'LotApproveButton',
  props: {
    lot: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
    },
    isPaymentAllowed: {
      type: Boolean,
      default: true,
    },
    isSameBusinessOwner: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["confirm", "loading"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const emits = __emit;

  const isOpenApproveModal = ref(false);
  const showLoader = ref(false);
  const showAttentionModal = ref(false);

  const onButtonApprove = () => {
    if (!props.isPaymentAllowed) {
      showAttentionModal.value = true;
    } else {
      isOpenApproveModal.value = true;
    }
  };

  function onCloseApproveModal() {
    isOpenApproveModal.value = false;
  }
  function onLoadingEvent() {
    showLoader.value = true;
    onCloseApproveModal();
    emits("loading");
  }
  function onConfirm() {
    showLoader.value = false;
    emits("confirm");
  }

const __returned__ = { props, emits, isOpenApproveModal, showLoader, showAttentionModal, onButtonApprove, onCloseApproveModal, onLoadingEvent, onConfirm, ref, LotApproveModal, AttentionModal, EOIApprovalModal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})